import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClientsService, IClientCard, IClientFormData } from 'src/app/_services/clients.service';
import { ClientState } from '../../state/client.state';
import { asArray, LxmAppModule, TenantStatus, UserAction } from 'src/app/enum';
import { ClientPaymentTerms } from '../../enum/ClientPaymentTerms';
import { StatusCircleStatus } from 'src/app/components';
import { AppState } from 'src/app/state/app.state';

@Component({
  selector: 'client-store-settings-card',
  templateUrl: './client-store-settings.card.html',
  styleUrls: ['./client-store-settings.card.scss']
})
export class ClientStoreSettingsCard implements OnInit {

  public edit = false;
  public saveLoading = false;
  public formData: IClientFormData;

  public paymentTermsOptions = asArray(ClientPaymentTerms);

  @Input() public clientId;

  private _snapshot;

  public form: FormGroup;

  public isStoreClientSet = false;
  public showStoreSettingsPanel = false;
  public canEditClientStoreSettings: boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _clientService: ClientsService,
    private _state: ClientState,
    private _appState: AppState) {

    const clientCard = this._route.snapshot.data.initialData?.clientCard as IClientCard;

    if (!clientCard) {
      return;
    }

    this.formData = clientCard.formData;
    const clientInfo = clientCard.clientInfo;
    this.isStoreClientSet = typeof clientInfo.isStoreClient === 'boolean';
    this.showStoreSettingsPanel = this.isStoreClientSet;
    this.canEditClientStoreSettings = this._appState.hasModule(LxmAppModule.SellerStore) &&
      this._appState.hasRights([UserAction.ManageClientStoreSettings]);

    this.form = new FormGroup({
      isStoreClient: new FormControl(clientInfo.isStoreClient ?? true),
      discountPercentage: new FormControl(clientInfo.storeDiscountPercentage),
      // paymentTerms: new FormControl(clientInfo.storePaymentTerms || ClientPaymentTerms.Prepayment)
    });
  }

  public get storeSettingsStatus() {
    return (this.isClientActive && this.isStoreClientSet && this._snapshot.isStoreClient) ? StatusCircleStatus.Active : StatusCircleStatus.Inactive;
  }

  public get clientTenantStatus() {
    return this._state.clientInfo.status as TenantStatus;
  }

  public get isClientActive() {
    return this.clientTenantStatus === TenantStatus.Active;
  }

  public get canEdit() {
    return this._state.canEdit && this._appState.hasRight([UserAction.ManageClientStoreSettings]);
  }

  public get canView() {
    return this._appState.hasRight([UserAction.ViewClientStoreSettings]);
  }

  public onInviteToStoreClick() {
    this.showStoreSettingsPanel = true;
    this.edit = true;
  }

  ngOnInit() {
    if (this.clientId) {
      this.saveInitialData();
    }
  }

  public toggleEdit() {
    if (this.edit) {

      if (!this.isStoreClientSet) {
        this.showStoreSettingsPanel = false;
      }

      this.revertToInitialData();
    }

    this.edit = !this.edit;
  }

  public saveInitialData() {
    this._snapshot = this.form.value;
  }

  public revertToInitialData() {
    this.form.patchValue(this._snapshot);
  }

  public save() {
    this.saveLoading = true;
    let req = this._createSaveRequest();

    this._clientService.saveStoreSettings(this.clientId, req)
      .result(this.form, () => {
        this.saveLoading = false;
        this.saveInitialData();
        this.edit = false;
        this.isStoreClientSet = true;
        this.showStoreSettingsPanel = true;
      }, error => { this.saveLoading = false; });
  }

  private _createSaveRequest() {
    const form = this.form.value;
    const req = {
      isStoreClient: form.isStoreClient,
      storeDiscountPercentage: form.discountPercentage,
      // storePaymentTerms: form.paymentTerms
    };

    return req;
  }
}

